import React from "react";
import ReactDOM from "react-dom";
import Overlay from "Shared/Overlay";
export var showPageNotice = function() {
    var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Sorry, we can't complete your request right now", type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "error", dismiss_timeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5000, class_name = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "page-notice";
    hidePageNotice(class_name);
    var allMessages = Array.isArray(message) ? message.join('<br />') : message;
    var newNotice = document.createElement("div");
    var transitionTime = 600; // milliseconds
    newNotice.classList.add(class_name);
    newNotice.style.top = "-80px";
    newNotice.style.transition = "top 600ms ease-in-out";
    if (type) newNotice.classList.add(type);
    newNotice.innerHTML = '\n      <div class="message-container">\n          <div class="message">\n              '.concat(allMessages, '\n          </div>\n          <button class="close" type="button">&times;</button>\n      </div>\n  ');
    newNotice.addEventListener("click", function() {
        return hidePageNotice(class_name);
    });
    document.body.appendChild(newNotice);
    setTimeout(function() {
        newNotice.style.transition = "top ".concat(transitionTime, "ms ease-in-out");
        newNotice.style.top = "0px";
    });
    if (type !== "error" || dismiss_timeout) {
        window.pageNoticeTimeout = setTimeout(function() {
            newNotice.style.transition = "top 600ms ease-in-out";
            newNotice.style.top = "-80px";
            setTimeout(function() {
                newNotice.remove();
                window.pageNoticeTimeout = null;
            }, transitionTime);
        }, dismiss_timeout);
    }
};
export var hidePageNotice = function(className) {
    var notice = document.querySelectorAll(className ? ".".concat(className) : ".page-notice");
    if (notice.length) {
        document.body.removeEventListener("click", function() {
            return hidePageNotice(className);
        });
        if (window.pageNoticeTimeout) {
            clearTimeout(window.pageNoticeTimeout);
        }
        notice = notice[0];
        notice.style.transition = "opacity 400ms ease-in-out";
        notice.style.opacity = "0";
        setTimeout(function() {
            notice.remove();
        }, 300);
    }
};
export var showWorkingOverlay = function() {
    var delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 500;
    if (document.getElementById("working-overlay")) return;
    var overlay = document.createElement("div");
    ReactDOM.render(/*#__PURE__*/ React.createElement(Overlay, {
        "data-testid": "working-overlay"
    }), overlay);
    overlay.id = "working-overlay";
    document.body.appendChild(overlay);
};
export var hideWorkingOverlay = function() {
    if (document.getElementById("working-overlay")) {
        document.getElementById("working-overlay").remove();
    }
};
